import * as types from "./mutation-types";

export default {
  [types.SET_IS_LOADING](state, payload) {
    state.isLoading = payload;
  },

  [types.SET_RANKING_LIST](state, payload) {
    state.rankingList = payload;
  },

  [types.SET_TOTAL_ITEMS](state, payload) {
    state.totalItems = payload;
  }
};
